var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.538 10.55L12.49 19.583M12.49 19.583C11.9659 20.1101 11.6717 20.8232 11.6717 21.5665C11.6717 22.3099 11.9659 23.023 12.49 23.55M12.49 19.583C12.231 19.8434 11.9231 20.0501 11.584 20.1911C11.2449 20.3322 10.8813 20.4049 10.514 20.405C10.1998 20.4021 9.89047 20.3263 9.61042 20.1837C9.33038 20.0411 9.08721 19.8355 8.90002 19.583",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.872 12.4359C22.772 13.5109 20.357 15.8919 18.152 18.0419L11.976 23.9989L6.5 25.2499L7.79 19.9359L9.34 18.4359L19.528 8.54994L20.649 7.45894C21.805 6.33794 23.382 6.62994 24.539 7.74994C24.9998 8.17552 25.3327 8.72136 25.5 9.32594",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.981 25.25H25.5",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f0333ef26e772ae93d355a3d47122467.svg";
export { ForwardRef as ReactComponent };